import { NgIf } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import {
    FormsModule,
    NgForm,
    ReactiveFormsModule,
    UntypedFormBuilder,
    UntypedFormGroup,
    Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import { FuseAlertComponent, FuseAlertType } from '@fuse/components/alert';
import { AuthenticationService } from 'app/services/authentication.service';
import { BaseRequestService } from "../../../_services/base.service";
import { CommonService } from "../../../_services/common.service";
import { OAuthService } from "angular-oauth2-oidc";
import { LoaderService } from "../../../_services/loader.service";
import { Subject, takeUntil } from 'rxjs';
import { environment } from 'environments/environment.development';
@Component({
    selector: 'auth-sign-in',
    templateUrl: './sign-in.component.html',
    styleUrls: ['./sign-in.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    standalone: true,
    imports: [
        RouterLink,
        FuseAlertComponent,
        NgIf,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatCheckboxModule,
        MatProgressSpinnerModule
    ],
})
export class AuthSignInComponent implements OnInit, OnDestroy {

    @ViewChild('signInNgForm') signInNgForm: NgForm;
    isLoading = true;
    alert: { type: FuseAlertType; message: string } = {
        type: 'success',
        message: '',
    };
    signInForm: UntypedFormGroup;
    showAlert: boolean = false;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    isFqdn = environment.isFqdn;
    /**
     * Constructor
     */
    constructor(
        public auth: AuthenticationService,
        private _activatedRoute: ActivatedRoute,
        private _formBuilder: UntypedFormBuilder,
        private _router: Router, public _bs: BaseRequestService,
        public cs: CommonService, private oauth: OAuthService,
        private ls: LoaderService,
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // if (environment.isFqdn) {
        //     this.isLoading = true;
        //     let url = `/${window.location.hostname}.json`;
        //     this.ls.display(true, 'Loading...');
        //     this._bs.doRequest(url, 'get').pipe(takeUntil(this._unsubscribeAll))
        //         .subscribe((result: any) => {
        //             this.ls.display(false);
        //             if (result && result.tenant_id) {
        //                 const res = {message: result};
        //                 console.log('scope value IDP true', res);
        //                 this.auth.updateClientID(res, true);
        //                 setTimeout(() => this.auth.authenticate());
        //                 this.isLoading = false;
        //             }
        //         });
        // }
        // Create the form
        const tenant_name = (this._activatedRoute.snapshot.queryParamMap.get('tenant_name')) ? this._activatedRoute.snapshot.queryParamMap.get('tenant_name') : '';
        const logout = (this._activatedRoute.snapshot.queryParamMap.get('state')) ? this._activatedRoute.snapshot.queryParamMap.get('state') : '';
        if (logout === 'logout') {
            window.location.href = '/sign-in'; return;
        }
        this.signInForm = this._formBuilder.group({
            company: [tenant_name, [Validators.required]]
        });
        this.ls.display(false);
        setTimeout(() => {
            if (this.oauth.hasValidAccessToken()) {
                this._router.navigate(['/overview']);
            }
            if (tenant_name && tenant_name.length) {
                console.log(tenant_name)
                this.getPartner();
            }
        }, 2000);
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    getPartner(isIDP?: boolean): void {
        if (this.signInForm.invalid) {
            return;
        }
        this.signInForm.disable();

        // Hide the alert
        this.showAlert = false;

        this._bs.doRequest(`${environment.configHost}/api/getPartner`, 'post', this.signInForm.value)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((result: any) => {
                if (result.status) {
                    if (result.message.maintenance && result.message.maintenance.indexOf(result.message.pod_id) > -1) {
                        this._router.navigate(['/maintenance']);
                        return;
                    }
                    this.auth.updateClientID(result, isIDP);
                    setTimeout(() => this.auth.authenticate());
                } else {
                    this.signInForm.enable();
                    this.showAlert = true;
                    this.alert.type = 'error'; this.alert.message = result.message;
                }
            })
    }

    tiggerAuthentication(): void {
        this.signInForm.disable();
        this.auth.authenticate();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Sign in
     */
}
